import com.voter.models.*
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.w3c.fetch.RequestInit
import kotlin.js.json

object ApiClient {
    private val json = Json { ignoreUnknownKeys = true }
    
    suspend fun createPoll(request: CreatePollRequest): Poll {
        val response = window.fetch("/api/polls", RequestInit(
            method = "POST",
            headers = json("Content-Type" to "application/json"),
            body = json.encodeToString(request)
        )).await()
        
        if (!response.ok) {
            throw Exception("Failed to create poll: ${response.statusText}")
        }
        
        return json.decodeFromString(response.text().await())
    }
    
    suspend fun getPoll(pollId: String): Poll {
        val response = window.fetch("/api/polls/$pollId").await()
        
        if (!response.ok) {
            throw Exception("Failed to get poll: ${response.statusText}")
        }
        
        return json.decodeFromString(response.text().await())
    }
    
    suspend fun submitVote(pollId: String, voteRequest: VoteRequest): Poll {
        val response = window.fetch("/api/polls/$pollId/vote", RequestInit(
            method = "POST",
            headers = json("Content-Type" to "application/json"),
            body = json.encodeToString(voteRequest)
        )).await()
        
        if (!response.ok) {
            val errorText = response.text().await()
            throw Exception("Failed to submit vote: $errorText")
        }
        
        return json.decodeFromString(response.text().await())
    }
    
    suspend fun updatePollStatus(pollId: String, status: PollStatus): Poll {
        val response = window.fetch("/api/polls/$pollId/status", RequestInit(
            method = "PUT",
            headers = json("Content-Type" to "application/json"),
            body = json.encodeToString(mapOf("status" to status.name))
        )).await()
        
        if (!response.ok) {
            val errorText = response.text().await()
            throw Exception("Failed to update poll status: $errorText")
        }
        
        return json.decodeFromString(response.text().await())
    }
    
    suspend fun getPollStatus(pollId: String): PollStatusResponse {
        val response = window.fetch("/api/polls/$pollId/status").await()
        
        if (!response.ok) {
            throw Exception("Failed to get poll status: ${response.statusText}")
        }
        
        return json.decodeFromString(response.text().await())
    }
}
